class ModuleService
{
    register(name, module)
    {
        elementorFrontend.hooks.addAction(`frontend/element_ready/${name}.default`, module);
    }
}

export default ModuleService;